<template>
    <!--理赔清单-->
  <div class="insure-claim">
    <p>
      电子数据保全法律费用损失保险理赔资料
    </p>
    <p>
      尊敬的被保险人：
    </p>
    <p>首先感谢使用华安保险的电子数据保全法律费用损失保险，出险时请拨打95556报案，并提前准以理赔资料。</p>

    <p>一、保单号</p>
    <p>二、被保险人身份证（个人）或单位证件、如营业执照复印件等。</p>
    <p>三、保全备案号</p>
    <p>四、人民法院收取诉讼费用时向诉讼当事人开具的缴费凭证。基层巡回法庭当场收取诉讼费用的，出具省级人民政府财政部门印制的财政票据原件； </p>
    <p>五、司法鉴定、公证费用及易保全出具易证据证书费用的发票原件； </p>
    <p>六、被保险人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料， 如民事诉讼状、法院判决书、调解书、仲裁报告等复印件。</p>
  </div>
</template>

<script>
    export default {
        name: "insureClaim"
    }
</script>

<style lang="less" scoped>
.insure-claim {
  max-width: 1200px;
  margin: 0 auto;
  border: 1px solid #dddddd;
  p {
    margin: 0 0 10px;
    font-size: 14px;
    color: #333333;
    line-height: 1.428;
  }
}
</style>



// WEBPACK FOOTER //
// pages/signInfo/insureClaim.vue